export default __webpack_public_path__ + "static/media/pictogramBeaconInstitution128.fd736230.svg";